/**
 * Confirm the microphone is usable *before* opening the recording tab.
 *
 * The recording tab opens in the background, and a permission prompt raised
 * there is invisible: the doctor would see nothing, grant nothing, and the
 * consultation would silently never record. Asking here, on the page they are
 * looking at, means the prompt is on screen and the answer is known before
 * anything else happens. Permission is per origin, so the new tab inherits it.
 */
export const ensureMicrophoneAccess = async (): Promise<boolean> => {
  if (!navigator.mediaDevices?.getUserMedia) return false;

  try {
    // Not implemented for "microphone" in every browser, hence the fallback.
    const status = await navigator.permissions
      ?.query({ name: "microphone" as PermissionName })
      .catch(() => null);

    if (status?.state === "granted") return true;
    if (status?.state === "denied") return false;

    // "prompt", or no Permissions API: ask now. The stream is released straight
    // away — this is only to settle permission, and holding the microphone here
    // would leave a recording indicator on the wrong tab.
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach((track) => track.stop());
    return true;
  } catch {
    return false;
  }
};
